export class EvaluationsModel{
    id?: number;
    eventId?: number;
    userId?: number;
    numberOfStars?: number;
    comment?:string;
    date?:Date;
    time?:Date;
    isHide?:boolean;

    


    constructor(item?:EvaluationsModel){
        item = item? item:{};
        this.id = item.id? item.id:0;
        this.eventId = item.eventId? item.eventId:0;
        this.userId = item.userId? item.userId:0;
        this.numberOfStars = item.numberOfStars? item.numberOfStars:0;
        this.comment = item.comment? item.comment:'';
        this.date = item.date? item.date:new Date();
        this.time = item.time? item.time:new Date();
        this.isHide = item.isHide? item.isHide:false;
      
        
    
    }

}